/**
 * Composed Chart  component Create Legend
 *
 * @package ext-components-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import { TComponentComposedChart_Props } from "./props";

/**
 * Creates legend
 */
export function createLegend(
	legend: TComponentComposedChart_Props["legend"],
	root: am5.Root,
	chart: am5xy.XYChart,
	spacing: number
): void {
	if (!legend) {
		return null;
	}

	const chartLegend = chart.children.push(
		am5.Legend.new(root, {
			x: am5.p50,
			centerX: am5.p50,
			marginTop: spacing,
			cursorOverStyle: "pointer"
		})
	);

	chartLegend.data.setAll(chart.series.values);
}
